import { ArrowRight } from "lucide-react";
import "./theme.css";

/**
 * 공유 카드 허브 그리드 — 관세 제도 안내 / 통관정보 등 "카드뉴스식" 랜딩 통일용.
 * cards: [{ id, icon?, title, meta?, desc?, accent?, count?, onClick }]
 * footer: 하단 안내 JSX(선택).
 */
export default function HubGrid({ title, subtitle, cards, footer }) {
  return (
    <div
      className="audit-root"
      style={{
        height: "100%",
        overflow: "auto",
        background: "var(--audit-bg)",
        padding: "22px 24px",
      }}
    >
      <div style={{ maxWidth: 920, margin: "0 auto" }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: "0 0 4px" }}>
          {title}
        </h1>
        {subtitle && (
          <div
            style={{
              fontSize: 13,
              color: "var(--audit-text-muted)",
              marginBottom: 20,
            }}
          >
            {subtitle}
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 14,
          }}
        >
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <button
                key={c.id}
                onClick={c.onClick}
                style={{
                  textAlign: "left",
                  border: "1px solid var(--audit-border)",
                  borderRadius: 12,
                  background: "var(--audit-bg)",
                  padding: "16px 16px 14px",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  transition: "border-color .12s, box-shadow .12s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "var(--audit-text-faint)";
                  e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.06)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "var(--audit-border)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {Icon && (
                    <span
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 9,
                        background: "var(--audit-bg-subtle)",
                        color: "var(--audit-text-muted)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon size={19} />
                    </span>
                  )}
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 800 }}>{c.title}</div>
                    {c.meta && (
                      <div
                        style={{
                          fontSize: 11.5,
                          color: "var(--audit-text-muted)",
                        }}
                      >
                        {c.meta}
                      </div>
                    )}
                  </div>
                  {c.count != null && (
                    <span
                      style={{
                        fontSize: 12.5,
                        fontWeight: 700,
                        color: "var(--audit-text-muted)",
                        flexShrink: 0,
                      }}
                    >
                      {Number(c.count).toLocaleString()}
                    </span>
                  )}
                </div>
                {c.desc && (
                  <div
                    style={{
                      fontSize: 12.5,
                      lineHeight: 1.6,
                      color: "var(--audit-text)",
                      flex: 1,
                    }}
                  >
                    {c.desc}
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: "var(--audit-text-muted)",
                  }}
                >
                  자세히 보기 <ArrowRight size={14} />
                </div>
              </button>
            );
          })}
        </div>

        {footer && <div style={{ marginTop: 22 }}>{footer}</div>}
      </div>
    </div>
  );
}
